import React from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';

import { useTimeModal } from '../TimeModal/TimeModalContext';

import CardOfCase from '../CardOfCase';
import Search from '../Search';
import HeaderPanel from '../HeaderPanel';
import InfoBlock from '../InfoBlock';

import Loading from '../Loading';
import LoadingLines from '../LoadingLines';

import headerPanel from '../../styles/HeaderPanel.module.css';

const AMTable = () => {
    const { openTimeModal } = useTimeModal();
    const [cases, setCases] = React.useState([]);
    const [warning, setWarning] = React.useState('');
    const [reload, setReload] = React.useState(true);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        const token = localStorage.getItem('token');
        axios.get('/api/cases-for-AM', {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then(response => {
            if (response.data.length === 0) {
                setWarning('За вашим адресом электронной почты не закреплено ни одно дело. Если Вы знаете, что это ошибка, напишите в поддержку.');
                setCases([]);
            } else {
                setWarning('');
                setCases(response.data);
            }
        })
        .catch(error => {
            setWarning(`Ошибка при загрузке таблицы дел:  ${error.response?.data.message || error.message}`);
        })
        .finally(() => {
            setLoading(false);
            setReload(false);
        });
    }, [reload]);

  const [idCaseForModal, setIdCaseForModal] = React.useState('');
  const [isCardOfCaseModal, setIsCardOfCaseModal] = React.useState(false);
  const [isSearch, setIsSearch] = React.useState(false);

  const formatDate = (dateString) => {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}.${month}.${year}`;
  };
  const formatComment = (comment) => {
    if (comment === 'Заметка отсутствует') {
        return <span style={{color: 'rgb(169, 169, 169)'}}>{comment}</span>
    }else {
        const truncatedComment = comment.length > 120 ? comment.substring(0, 120) + '...' : comment;
        return <span>{truncatedComment}</span>;
    }
  };
  
  // Функция для покраски просроченных дел в списке
  const getCaseStyle = (caseItem) => {
    const todayMSC = new Date();
    todayMSC.setHours(todayMSC.getHours() + 3); // Перевод времени в МСК

    const isPastEndDate =
        new Date(caseItem.date_end) < todayMSC && caseItem.status !== 'Завершено';

    if (isPastEndDate) {
        return { border: '1px solid rgb(255, 14, 14)', backgroundColor: 'rgb(255, 247, 247)' };
    }
};

  return (
    <>
      {isCardOfCaseModal && <CardOfCase closeModal={() => {setIsCardOfCaseModal(false)}} id={idCaseForModal} onCardOfCaseSuccess={() => {setReload(true)}} />}
      <div className='mainContainer'>
      <InfoBlock />
      <HeaderPanel typePanel='Арбитражный управляющий' />
      <div className={headerPanel.additionalPanel}>
        <a></a>
          {/* <span className={styles.sortContainer}>
              <a className={styles.headline}>Сортировать: </a>
              <div>
                  <a>по дате</a>
                  <a>по номеру</a>
                  <a>по статусу</a>
              </div>
          </span> */}
        <a>Арбитражный управляющий</a>
      </div>
        <motion.div
            initial={{ scale: '97%', opacity: 0 }}
            animate={{ scale: '100%', opacity: 1 }}
            exit={{ scale: '97%', opacity: 0 }}
            transition={{ duration: 0.3 }}
        >
            <div className='table-container'>
                <div className='tableHeader'>
                    <a className='numberCase'>Номер</a>
                    <a className='categoryCase'>Этап</a>
                    <a className='applicantCase'>Истец</a>
                    <a className='commentsCase'>Комментарий</a>
                    <a className='datesCase'>Начальная дата / Конечная дата</a>
                    <a className='statusCase'>Статус</a>
                </div>
                {loading && <LoadingLines />}
                {warning && <div className='case warningLine'><a>{warning}</a></div>}
                {cases.map((caseItem) => (
                    <a className='case' key={caseItem.id} style={getCaseStyle(caseItem)} onClick={() => {setIsCardOfCaseModal(true); setIdCaseForModal(caseItem.id)}}>
                        <a className='numberCase'>{caseItem.is_favorite ? (<svg style={{width: '15px', marginRight: '5px'}} viewBox="0 0 24 24" id="bookmark-full"><path fill="currentColor" d="M18,2H6A1,1,0,0,0,5,3V21a1,1,0,0,0,1.65.76L12,17.27l5.29,4.44A1,1,0,0,0,18,22a.84.84,0,0,0,.38-.08A1,1,0,0,0,19,21V3A1,1,0,0,0,18,2ZM17,18.86,12.64,15.2a1,1,0,0,0-1.28,0L7,18.86V4H17Z"></path></svg>) : (<></>)}{caseItem.number}</a>
                        <a className='categoryCase'>{caseItem.status=="В работе" ? (caseItem.namePhase) : (<>Дело завершено</>)}</a>
                        <a className='applicantCase'>{caseItem.applicant}</a>
                        <a className='commentsCase'>{formatComment(caseItem.comments)}</a>
                        <a className='datesCase'>{formatDate(caseItem.date_start)} / {formatDate(caseItem.date_end)}</a>
                        <a className='statusCase' style={{borderBottom: 'none', borderRight: 'none'}}>{caseItem.status}</a>
                    </a>
                ))}
            </div>
        </motion.div>
      </div>
    </>
  )
}

export default AMTable;